export default "__VITE_ASSET__DupmcJdc__"